import React from "react";
import { RouteObject } from "react-router-dom";
import { adCopyClientEndpoint } from "../../../../routes/adCopyEndpoint";
import { AdCopyWithAuth } from "../../auth";
import { adCopyLatestVersion } from "../../../../../../shared/version";
import { AdCopyConceptReportContainer } from "./concept";
import { AdCopyOAReportContainer } from "./oa";
import { AdCopyKeyMeasurementsReportContainer } from "./key-measurements";
import { AdCopySimulationContainer } from "./simulation";
import { AdCopyOutlineContainer } from "./outline";
import { AdCopyResultByTargetReportContainer } from "./result-by-target";
import { AdCopyDownloadReportContainer } from "./download";

export const adCopyLatestReportPages: RouteObject[] = [
	// report
	{
		path: adCopyClientEndpoint.outlineLatest,
		element: (
			<AdCopyWithAuth isReportPage version={adCopyLatestVersion}>
				<AdCopyOutlineContainer />
			</AdCopyWithAuth>
		),
	},
	{
		path: adCopyClientEndpoint.resultByTargetReportLatest,
		element: (
			<AdCopyWithAuth isReportPage version={adCopyLatestVersion}>
				<AdCopyResultByTargetReportContainer />
			</AdCopyWithAuth>
		),
	},
	{
		path: adCopyClientEndpoint.downloadReportLatest,
		element: (
			<AdCopyWithAuth isReportPage version={adCopyLatestVersion}>
				{(account) => <AdCopyDownloadReportContainer {...account} />}
			</AdCopyWithAuth>
		),
	},
	{
		path: adCopyClientEndpoint.conceptReportLatest,
		element: (
			<AdCopyWithAuth doNotUseTab version={adCopyLatestVersion}>
				<AdCopyConceptReportContainer />
			</AdCopyWithAuth>
		),
	},
	{
		path: adCopyClientEndpoint.oaReportLatest,
		element: (
			<AdCopyWithAuth isReportPage version={adCopyLatestVersion}>
				<AdCopyOAReportContainer />
			</AdCopyWithAuth>
		),
	},
	{
		path: adCopyClientEndpoint.keyMeasurementsReportLatest,
		element: (
			<AdCopyWithAuth isReportPage version={adCopyLatestVersion}>
				<AdCopyKeyMeasurementsReportContainer />
			</AdCopyWithAuth>
		),
	},
	{
		path: adCopyClientEndpoint.simulationReportLatest,
		element: (
			<AdCopyWithAuth isReportPage version={adCopyLatestVersion}>
				{(account) => <AdCopySimulationContainer {...account} />}
			</AdCopyWithAuth>
		),
	},
];
